import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStackletLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 24,
	title: "stacklet",
	viewBox: "0 0 23 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3087 0L0.785645 7.00555V7.08568V10.3332V10.4133L2.56711 11.5994L0.785645 12.7851V12.8653V16.1929L11.3087 23.1984V23.1989L21.8322 16.1933V16.1132V12.8657V12.7856L20.0507 11.5994L21.8322 10.4138V10.3336V7.08611V7.00599L11.3087 0ZM19.393 14.4892L17.5515 15.7148L11.3087 19.8708L3.2248 14.4892L5.06634 13.2637L11.3087 17.4193L15.0523 14.9271V11.5999L17.5515 13.2633V13.2637L19.393 14.4892ZM17.5515 9.93518L11.3087 5.77958L6.90787 8.70921L9.4071 10.373L11.3087 9.10722L15.0518 11.599L11.3087 14.0912L7.56556 11.5994V11.599L5.06634 9.93518L3.2248 8.70921L5.06634 7.48324L11.3087 3.32764L19.393 8.70921L17.5515 9.93518Z",
		fill: "currentColor"
	})
});
export default SvgStackletLogo;
